import { validate } from '../SignUp/validator';

const validatePasswordFields = (newPassword, currentPassword, tr) => {
  const passwordErrors = {};

  if (!newPassword) {
    passwordErrors.newPassword = '';
    passwordErrors.currentPassword = '';

    return passwordErrors;
  }

  const newPasswordValidation = validate('password', newPassword);
  const currentPasswordValidation = validate('password', currentPassword);

  if (!newPasswordValidation.isValid) {
    passwordErrors.newPassword =
      tr(newPasswordValidation.translationKey, { isError: true }) ||
      newPasswordValidation.message;
  }

  if (!currentPasswordValidation.isValid) {
    passwordErrors.currentPassword =
      tr(currentPasswordValidation.translationKey, { isError: true }) ||
      currentPasswordValidation.message;
  }

  return passwordErrors;
};

const validateForm = ({ newPassword, currentPassword, ...rest }, tr) => {
  const newErrors = {};

  Object.entries(rest).forEach(([key, value]) => {
    const { isValid, message, translationKey } = validate(key, value);
    newErrors[key] = isValid ? '' : tr(translationKey, { isError: true }) || message;
  });

  Object.assign(newErrors, validatePasswordFields(newPassword, currentPassword, tr));

  return newErrors;
};

export default validateForm;
